import { Input } from "../client/components/ui/input";
import { Label } from "../client/components/ui/label";
import useTranslation from "../client/hooks/useTranslation";
import type { PayoutFormValues } from "./payoutForm";

interface Props {
  values: PayoutFormValues;
  onChange: (values: PayoutFormValues) => void;
  /** Masque libellés et aides (lignes 2+ de la saisie multiple du PFM). */
  hideLabels?: boolean;
  /** Masque les aides sous les champs (lignes alignées d'une grille). */
  hideHints?: boolean;
  idPrefix?: string;
}

/**
 * Brut / net d'un payout. Le BRUT est débité du compte (drawdown), le NET est
 * ce que le trader reçoit (gains). Voir payoutForm.ts.
 */
export default function PayoutAmountFields({ values, onChange, hideLabels = false, hideHints = false, idPrefix = "payout" }: Props) {
  const t = useTranslation();
  const set = (patch: Partial<PayoutFormValues>) => onChange({ ...values, ...patch });
  const field = (key: keyof PayoutFormValues, label: string, hint: string) => (
    <div className="space-y-1 min-w-0">
      {!hideLabels && (
        <Label htmlFor={`${idPrefix}-${key}`} className="block text-xs text-muted-foreground">
          {label}
        </Label>
      )}
      <Input
        id={`${idPrefix}-${key}`}
        type="number"
        min="0"
        step="0.01"
        placeholder="0.00"
        value={values[key]}
        onChange={(e) => set({ [key]: e.target.value })}
        className="h-9 font-mono"
      />
      {!hideLabels && !hideHints && <p className="text-[11px] leading-tight text-muted-foreground">{hint}</p>}
    </div>
  );

  return (
    <div className="grid grid-cols-2 gap-3 items-start">
      {field("gross", t.tradingAccounts.payoutGrossAmount, t.tradingAccounts.payoutGrossHint)}
      {field("net", t.tradingAccounts.payoutNetAmount, t.tradingAccounts.payoutNetHint)}
    </div>
  );
}
